import { TStandardSectionStep } from 'models';
import React from 'react';
import { DrawerDataFormControls, DrawerDataFormControlsButton } from './styles';
import { translate } from 'utils';

const SCROLL_STEP = 100;

export const renderControls = (step: TStandardSectionStep, isTouched: boolean, handleSaveData: () => void, allowCancel?: boolean, resetForm?: () => void, readOnly?: boolean) => (
  <DrawerDataFormControls step={step} touched={isTouched}>
    {allowCancel ? (
      <DrawerDataFormControlsButton size="l" preset="secondary" onClick={resetForm} disabled={readOnly}>
        {translate({ key: 'common.cancel' })}
      </DrawerDataFormControlsButton>
    ) : null}
    <DrawerDataFormControlsButton size="l" onClick={handleSaveData} disabled={readOnly}>
      {translate({ key: 'common.save' })}
    </DrawerDataFormControlsButton>
  </DrawerDataFormControls>
);

export const scrollElementToBottom = (element: HTMLDivElement | null) => {
  if (element !== null) {
    element.scrollBy({ top: SCROLL_STEP, behavior: 'smooth' });
  }
};

export const scrollElementToTop = (element: HTMLDivElement | null) => {
  if (element !== null) {
    element.scrollTo({ top: 0, behavior: 'smooth' });
  }
};
